<template>
	<div class="CourseSingupModalWarp">
		<el-dialog title="" :visible.sync="showRegist" width="720px" class="dialogWarp" :destroy-on-close="true"
		    :close-on-click-modal='false' :append-to-body="true" :show-close='false' :close-on-press-escape='false'>
			<div class="singupdialogcenter">
				<div class="hittext">账户设置</div>
				<div class="singupForm" v-if='!flagShow'>
					<el-form :model="formData" ref="formData" :rules='formRules' label-width="108px" class="demo-dynamic" >
						
						<el-form-item label="用户名" prop="userName">
							<el-input v-model="formData.userName" placeholder="请输入用户名(建议为'拼音+数字'组合)"></el-input>
						</el-form-item>
						<el-form-item label="手机号" prop="phoneNumber">
							<el-input v-model="formData.phoneNumber"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="password">
							<el-input type="password" v-model="formData.password" show-password></el-input>
						</el-form-item>
						<!-- <el-form-item label="再次输入密码" type="password" prop="affirmpassword">
							<el-input type="password" v-model="formData.affirmpassword"   show-password></el-input>
						</el-form-item> -->
						<!-- <div class="attentionBox">
						注：为了更好的用户体验，请完善用户信息！
						</div> -->
						<div class="formBtnBox">
							<el-button type="primary" @click="submitForm('formData')" class="submitBtn" :loading="isloading">提交</el-button>
							<!-- <el-button @click="offmodalFn" class="cancelBtn">取消</el-button> -->
						</div>
					</el-form>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
export default {
	props: {
		registVisible: {
			type: Boolean,
			default: false
		},
		firstFormData: {
			type: Object,
			default: null,
		},
	},
	data() {
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.formData.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		let checkData = (rule, value, callback) => {
			if (value) {
				if (/[\u4E00-\u9FA5]/g.test(value)) {
					callback(new Error('用户名不能输入汉字,建议以"拼音+数字"组合!'));
				} else {
					callback();
				}
			}
			callback();
		}
		return {
			showRegist: true,
			active: 0,
			// 报名表单
			formData: {
				// 个人
				userName: null,
				phoneNumber:'',
				password: '',
				// affirmpassword: '',
			},
			formRules: {
				userName: [
					{ required: true, message: '请输入用户名,用户名建议以"拼音+数字"组合', trigger: 'blur' },

					{ validator: checkData, trigger: 'blur' }

				],
				 phoneNumber: [
                    {
                        required: true,
                        message: '请输入手机号码', trigger: 'blur',

                    },
                    { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的手机号码', }
                ],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
				// affirmpassword: [
				// 	{ required: true, message: '请再次确认密码', trigger: 'blur' },
				// 	{ validator: validatePass2, trigger: 'blur', required: true }
				// ],
			},
			isloading: false,
			flagShow: false,
			resultData: null
		}
	},
	methods: {
		// 报名表单
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.isloading = true
					this.formData.userId=JSON.parse(sessionStorage.getItem('userInfo')).userId
					httpService.updateUserName(this.formData).then(res=>{
						if(res.code==200){
							this.$message.success('账户设置成功')
							this.$emit('offWechartModal', false)
						}
					})
				} else {
					this.$nextTick(() => {
						formErrorScroll()
					})
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		// 关闭表单
		offmodalFn() {
			this.$emit('offWechartModal', false)
		},
	}

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	padding: 0px;
	/deep/.singupdialogcenter {
		padding: 0px 0px 0px 0px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;

		.courseBox1 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-bottom: 32px;
			border-bottom: 1px solid #dddddd;
			margin-bottom: 20px;
			.courseinfo {
				margin: 0 100px;
				font-size: 16px;
				line-height: 54px;
				color: #333333;
				.text {
					font-size: 16px;
					margin-right: 20px;
					line-height: 54px;
					color: #a6a9b7;
				}
			}
		}
		/deep/.el-checkbox__inner {
			border-radius: 50%;
		}
		.hittext {
					font-size: 18px;
					font-weight: bold;
				}
		.singupForm {
			width: 80%;
			margin-top: 30px;
			.attentionBox{
				color: #ff3c3c;
				font-size: 12px;
				margin: 30px 0 36px 0;
			}
			.singupInfowarp {
				padding-bottom: 32px;
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				// padding: 0 82px;
			}
			.singupInfobox {
				// padding-bottom: 32px;
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				padding: 0 50px;

				.header {
					margin-bottom: 12px;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
					}
				}
				// .honor {
				// 	// margin-left: 20px;
				// 	position: relative;
				// 	&::before {
				// 		position: absolute;
				// 		top: 16px;
				// 		left: -10px;
				// 		// margin-right: 4px;
				// 		color: #ff4d4f;
				// 		font-size: 16px;
				// 		font-family: SimSun, sans-serif;
				// 		line-height: 1;
				// 		content: '*';
				// 	}
				// }
				.btnwarp {
					font-size: 16px;
					// line-height: 54px;
					display: flex;
					flex-direction: row;
					justify-content: center;

					.icon {
						margin-right: 5px;
					}
					.addbtn {
						color: #0083ff;
						margin: 0 20px;
						cursor: pointer;
					}
					.deletebtn {
						color: #ff3c3c;
						margin: 0 20px;
						cursor: pointer;
					}
				}
			}
			.header {
				font-size: 18px;
				line-height: 54px;
				color: #333333;
				.education {
					font-size: 16px;
					line-height: 54px;
					color: #999999;
					padding-left: 6px;
				}
			}
			.educationInfoBox {
				.header {
					margin-left: 48px;
				}
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				// padding: 0 0px 30px 0px;
			}
			.makeoutInfoBox {
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				padding: 0 50px 30px 50px;
				.header {
					font-size: 18px;
					line-height: 54px;
					color: #333333;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
						padding-left: 6px;
					}
				}
			}

			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}
				.submitdraftBtn {
					width: 152px;
					height: 40px;
					background: #52ca9c;
					margin: 0 20px;
					color: #fff;
				}
				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
		}
	}
	.yearbox {
		font-size: 15px;
		line-height: 40px;
		color: #a6a9b7;
		&::before {
			position: absolute;
			top: 12px;
			left: 0px;
			// margin-right: 4px;
			color: #ff4d4f;
			font-size: 16px;
			font-family: SimSun, sans-serif;
			line-height: 1;
			content: '*';
		}
	}
	.deteleIcon {
		font-size: 21px;
		cursor: pointer;
		color: red;
		line-height: 40px;
		margin-left: 4px;
	}
}
// /deep/.el-step__title.is-process {
// 	color: #349cff;
// }
// /deep/.el-step__head.is-process {
// 	color: #349cff;
// }
// /deep/.el-step__icon is-text {
// 	color: #349cff;
// 	border: 1px solid #349cff;
// 	border-radius: 0;
// 	transform: rotate(45deg);
// }
// /deep/.el-step__icon-inner {
// 	transform: rotate(-45deg);
// }
// /deep/.el-step__icon{
//     color: #349CFF;
//     border: 1px solid #349CFF;
// }

// 默认当前激活步骤显示的是黑色，这里修改显示为蓝色
::v-deep .el-step__head.is-process {
	color: #1890ff !important; // 圆圈中数字
	border-color: #1890ff !important; // 圆圈
}
::v-deep .el-step__title.is-process {
	color: #1890ff !important; // 圆圈下的标题文本
}
</style>


